module.exports = __webpack_public_path__ + "img/learner-quiz-Connoisseur.d292e0f5.png";